<div class="sidebar-reference-comments"><app-loading [isLoading]="isLoading">
  <div class="card v-card mb-4 fadeIn">
    <div class="card-body">
      <h5 class="card-title">{{ 'COMMENTS.ADD_COMMENT' | translate }}</h5><textarea class="form-control mb-2" rows="3" [(ngModel)]="newCommentContent" [placeholder]="'COMMENTS.PLACEHOLDER' | translate"></textarea><button class="btn v-btn-primary" type="button" [disabled]="!newCommentContent.trim() || isSaving" (click)="addComment()">@if (isSaving) {
      <span class="spinner-border spinner-border-sm me-1"></span>
    }{{ 'COMMENTS.ADD' | translate }}</button>
  </div>
</div>@if (comments.length > 0) {
@for (comment of comments; track trackByFn($index, comment)) {
  <div class="comment-item card v-card mb-3 fadeIn">
    <div class="card-body">
      <div class="comment-header d-flex justify-content-between align-items-start mb-2">
        <div class="comment-meta"><strong class="comment-author text-dark">{{ comment.author_full_name }}</strong><small class="text-muted ms-2">{{ comment.created_at | date:'medium' }}</small></div>
        @if (isAuthor(comment)) {
          <div class="comment-actions">@if (editingCommentId !== comment.id) {
            <button class="btn btn-sm btn-outline-secondary me-1" type="button" (click)="startEdit(comment)" [tooltip]="'COMMON.EDIT' | translate" container="body"><i class="lnr lnr-pencil" aria-hidden="true"></i></button>
            }<button class="btn btn-sm btn-outline-danger" type="button" (click)="deleteComment(comment)" [tooltip]="'COMMON.DELETE' | translate" container="body"><i class="lnr lnr-trash" aria-hidden="true"></i></button></div>
          }
        </div>
        @if (editingCommentId !== comment.id) {
          <div class="comment-content text-break">
            <p class="mb-0">{{ comment.content }}</p>
          </div>
        }
        @if (editingCommentId === comment.id) {
          <div class="comment-edit"><textarea class="form-control mb-2" rows="3" [(ngModel)]="editingContent"></textarea>
          <div class="edit-actions"><button class="btn btn-sm v-btn-primary me-1" type="button" [disabled]="!editingContent.trim() || isSaving" (click)="saveEdit(comment)">{{ 'COMMON.SAVE' | translate }}</button><button class="btn btn-sm btn-secondary" type="button" (click)="cancelEdit()">{{ 'COMMON.CANCEL' | translate }}</button></div>
        </div>
      }
    </div>
  </div>
}
}
@if (comments.length === 0) {
  <div class="empty-state text-center text-muted py-4"><span class="lnr lnr-bubble d-block mb-3" style="font-size: 3rem;"></span>
  <p>{{ 'COMMENTS.EMPTY' | translate }}</p>
</div>
}
</app-loading></div>
